import {t} from "@lingui/core/macro";

type LanguageCode = string;
export interface LanguageData {
    languageName: string;
    url?: string;
    teamUrl?: string;
    countries: Array<string>;
}

// sync-start:locales 2081014618 https://github.com/Khan/webapp/blob/master/pkg/services_shared/intl/ka_locales.go
export const getLanguages = (): Map<LanguageCode, LanguageData> =>
    new Map([
        [
            "am",
            {
                languageName: t`Amharic`,
                countries: ["ET"],
            },
        ],
        [
            "ar",
            {
                languageName: t`Arabic`,
                url: "https://ar.khanacademy.org",
                countries: [
                    "DZ",
                    "BH",
                    "TD",
                    "KM",
                    "DJ",
                    "EG",
                    "ER",
                    "IQ",
                    "JO",
                    "KW",
                    "LB",
                    "LY",
                    "MR",
                    "MA",
                    "OM",
                    "PS",
                    "QA",
                    "SA",
                    "SO",
                    "SD",
                    "SY",
                    "TZ",
                    "TN",
                    "AE",
                    "YE",
                ],
            },
        ],
        [
            "as",
            {
                languageName: t`Assamese`,
                countries: ["IN"],
                url: "https://as.khanacademy.org/",
            },
        ],
        [
            "az",
            {
                languageName: t`Azerbaijani`,
                url: "https://az.khanacademy.org/",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360040712732-Az%C9%99rbaycan-komandas%C4%B1-Azerbaijani-Team-",
                countries: ["AZ"],
            },
        ],
        [
            "bg",
            {
                languageName: t`Bulgarian`,
                url: "https://bg.khanacademy.org/",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360010442672-%D0%91%D1%8A%D0%BB%D0%B3%D0%B0%D1%80%D1%81%D0%BA%D0%B8%D1%8F%D1%82-%D0%B5%D0%BA%D0%B8%D0%BF-The-Bulgarian-Team",
                countries: ["BG"],
            },
        ],
        [
            "bn",
            {
                languageName: t`Bangla`,
                url: "https://bn.khanacademy.org/",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360035818672-%E0%A6%AC%E0%A6%BE%E0%A6%82%E0%A6%B2%E0%A6%BE-%E0%A6%A6%E0%A6%B2-The-Bangla-team",
                countries: ["IN", "BD"],
            },
        ],
        [
            "cs",
            {
                languageName: t`Czech`,
                url: "https://cs.khanacademy.org",
                teamUrl:
                    "https://support.khanacademy.org/hc/en-us/articles/360048926171-%C4%8Cesk%C3%BD-t%C3%BDm-The-Czech-Team",
                countries: ["CZ"],
            },
        ],
        [
            "da",
            {
                languageName: t`Danish`,
                url: "https://da.khanacademy.org",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360020642472-Det-danske-hold-The-Danish-Team",
                countries: ["DK", "GL", "FO"],
            },
        ],
        [
            "de",
            {
                languageName: t`German`,
                url: "https://de.khanacademy.org/",
                teamUrl: "https://www.kadeutsch.org/",
                countries: ["DE", "CH", "AT", "LI", "LU", "BE"],
            },
        ],
        [
            "el",
            {
                languageName: t`Greek`,
                url: "https://el.khanacademy.org",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360021573432-%CE%97-%CE%95%CE%BB%CE%BB%CE%B7%CE%BD%CE%B9%CE%BA%CE%AE-%CE%9F%CE%BC%CE%AC%CE%B4%CE%B1-The-Greek-Team",
                countries: ["GR", "AL", "CY"],
            },
        ],
        [
            "en",
            {
                languageName: t`English`,
                url: "https://www.khanacademy.org/",
                countries: ["US", "CA", "GB", "AU", "IE", "NZ"],
            },
        ],
        [
            "es",
            {
                languageName: t`Spanish`,
                url: "https://es.khanacademy.org/",
                countries: [
                    "AR",
                    "BO",
                    "CL",
                    "CR",
                    "CU",
                    "DO",
                    "EC",
                    "SV",
                    "GQ",
                    "GT",
                    "HN",
                    "MX",
                    "NI",
                    "PA",
                    "PY",
                    "PE",
                    "ES",
                    "UY",
                    "VE",
                ],
            },
        ],
        [
            "fa",
            {
                languageName: t`Persian`,
                url: "https://fa.khanacademy.org",
                countries: ["IR", "AF", "TJ", "IQ", "AZ"],
            },
        ],
        [
            "fa-af",
            {
                languageName: t`Dari`,
                url: "https://fa-af.khanacademy.org",
                countries: ["AF"],
            },
        ],
        [
            "fr",
            {
                languageName: t`French`,
                url: "https://fr.khanacademy.org/",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360020640812-L-%C3%A9quipe-francophone-The-French-Team",
                countries: [
                    "FR",
                    "CA",
                    "BE",
                    "CM",
                    "CD",
                    "GQ",
                    "HT",
                    "CI",
                    "LU",
                    "MG",
                    "NE",
                    "RW",
                ],
            },
        ],
        ["fv", {languageName: t`Fulfulde`, countries: ["CM"]}],
        [
            "gu",
            {
                languageName: t`Gujarati`,
                url: "https://gu.khanacademy.org",
                countries: ["IN"],
            },
        ],
        [
            "he",
            {
                languageName: t`Hebrew`,
                url: "https://he.khanacademy.org",
                countries: ["IL"],
            },
        ],
        [
            "hi",
            {
                languageName: t`Hindi`,
                url: "https://hi.khanacademy.org",
                countries: ["IN", "NP"],
            },
        ],
        [
            "hu",
            {
                languageName: t`Hungarian`,
                url: "https://hu.khanacademy.org",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360016289291-A-magyar-csapat-The-Hungarian-Team",
                countries: ["HU"],
            },
        ],
        [
            "hy",
            {
                languageName: t`Armenian`,
                url: "https://hy.khanacademy.org/",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360022981172-%D5%80%D5%A1%D5%B5%D5%A1%D5%AC%D5%A5%D5%A6%D5%B8%D6%82-%D5%A9%D5%AB%D5%B4-The-Armenian-Team",
                countries: ["AM"],
            },
        ],
        [
            "id",
            {
                languageName: t`Indonesian`,
                url: "https://id.khanacademy.org",
                countries: ["ID"],
            },
        ],
        ["is", {languageName: t`Icelandic`, countries: ["IS"]}],
        [
            "it",
            {
                languageName: t`Italian`,
                url: "https://it.khanacademy.org",
                countries: ["IT", "CH"],
            },
        ],
        [
            "ja",
            {
                languageName: t`Japanese`,
                url: "https://ja.khanacademy.org",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360016049411-%E6%97%A5%E6%9C%AC%E8%AA%9E%E5%8C%96%E3%83%81%E3%83%BC%E3%83%A0-The-Japanese-Team",
                countries: ["JP"],
            },
        ],
        [
            "ka",
            {
                languageName: t`Georgian`,
                url: "https://ka.khanacademy.org/",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360009070571-%E1%83%A5%E1%83%90%E1%83%A0%E1%83%97%E1%83%A3%E1%83%9A%E1%83%98-%E1%83%92%E1%83%A3%E1%83%9C%E1%83%93%E1%83%98-The-Georgian-team",
                countries: ["GE"],
            },
        ],
        [
            "kk",
            {
                languageName: t`Kazakh`,
                url: "https://kk.khanacademy.org/",
                countries: ["KZ"],
            },
        ],
        [
            "km",
            {
                languageName: t`Khmer`,
                url: "https://km.khanacademy.org/",
                countries: ["KH", "TH", "VN"],
            },
        ],
        [
            "kn",
            {
                languageName: t`Kannada`,
                url: "https://kn.khanacademy.org",
                countries: ["IN"],
            },
        ],
        [
            "ko",
            {
                languageName: t`Korean`,
                url: "https://ko.khanacademy.org",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360020896531-%ED%95%9C%EA%B5%AD%ED%8C%80-The-Korean-Team",
                countries: ["KP", "KR"],
            },
        ],
        [
            "ky",
            {
                languageName: t`Kyrgyz/Khirgiz`,
                url: "https://ky.khanacademy.org",
                countries: ["KG"],
            },
        ],
        [
            "lt",
            {
                languageName: t`Lithuanian`,
                url: "https://lt.khanacademy.org/",
                teamUrl:
                    "https://support.khanacademy.org/hc/en-us/articles/4422809940621-Lietuvi%C5%B3-komanda-The-Lithuanian-Team",
                countries: ["LT"],
            },
        ],
        [
            "lv",
            {
                languageName: t`Latvian`,
                url: "https://lv.khanacademy.org/",
                teamUrl:
                    "https://support.khanacademy.org/hc/en-us/articles/4407784419341-Latvie%C5%A1u-valodas-komanda-The-Latvian-team",
                countries: ["LV"],
            },
        ],
        [
            "mn",
            {
                languageName: t`Mongolian`,
                url: "https://mn.khanacademy.org",
                countries: ["MN"],
            },
        ],
        [
            "mr",
            {
                languageName: t`Marathi`,
                countries: ["IN"],
                url: "https://mr.khanacademy.org/",
            },
        ],
        [
            "ms",
            {
                languageName: t`Malay`,
                url: "https://ms.khanacademy.org",
                countries: ["MY"],
            },
        ],
        [
            "my",
            {
                languageName: t`Burmese`,
                url: "https://my.khanacademy.org/",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360020696512-%E1%80%99%E1%80%BC%E1%80%94-%E1%80%99%E1%80%AC%E1%80%A1%E1%80%9E%E1%80%84-%E1%80%B8-The-Burmese-team",
                countries: ["MM"],
            },
        ],
        [
            "nb",
            {
                languageName: t`Norwegian Bokmål`,
                url: "https://nb.khanacademy.org/",
                countries: ["NO"],
            },
        ],
        [
            "nl",
            {
                languageName: t`Dutch`,
                url: "https://nl.khanacademy.org",
                teamUrl:
                    "https://support.khanacademy.org/hc/en-us/articles/360059927231-Het-Nederlandse-Vlaamse-team-The-Dutch-Flemish-Team",
                countries: ["NL", "BE", "SR", "AW", "CW", "SX"],
            },
        ],
        [
            "or",
            {
                languageName: t`Odia`,
                countries: ["IN"],
                url: "https://or.khanacademy.org/",
            },
        ],
        [
            "pa",
            {
                languageName: t`Punjabi`,
                url: "https://pa.khanacademy.org/",
                countries: ["IN", "PK"],
            },
        ],
        [
            "pl",
            {
                languageName: t`Polish`,
                url: "https://pl.khanacademy.org/",
                countries: ["PL"],
            },
        ],
        [
            "ps",
            {
                languageName: t`Pashto`,
                url: "https://www.youtube.com/channel/UC7OMM-IeI3VU6FyHDDzzpdQ",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360035494331-The-Pashto-team-د-پښتو-ټیم-",
                countries: ["AF", "PK", "IN"],
            },
        ],
        [
            "pt",
            {
                languageName: t`Portuguese (Brazil)`,
                url: "https://pt.khanacademy.org/",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360006952791-O-time-Brasil-The-Brazilian-Portuguese-team",
                countries: [
                    "BR",
                    "AO",
                    "CV",
                    "GQ",
                    "GW",
                    "MO",
                    "MZ",
                    "PT",
                    "ST",
                    "TL",
                ],
            },
        ],
        [
            "pt-pt",
            {
                languageName: t`Portuguese (Portugal)`,
                url: "https://pt-pt.khanacademy.org",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360031879052-A-equipa-em-Portugal-The-European-Portuguese-team",
                countries: [
                    "PT",
                    "BR",
                    "AO",
                    "CV",
                    "GQ",
                    "GW",
                    "MO",
                    "MZ",
                    "ST",
                    "TL",
                ],
            },
        ],
        [
            "ro",
            {
                languageName: t`Romanian`,
                url: "https://ro.khanacademy.org/",
                teamUrl:
                    "https://support.khanacademy.org/hc/en-us/articles/360058649011-Echipa-Rom%C3%A2niei-The-Romanian-Team",
                countries: ["RO"],
            },
        ],
        [
            "ru",
            {
                languageName: t`Russian`,
                url: "https://ru.khanacademy.org",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360020641352-%D0%A0%D1%83%D1%81%D1%81%D0%BA%D0%BE%D1%8F%D0%B7%D1%8B%D1%87%D0%BD%D0%B0%D1%8F-%D0%BA%D0%BE%D0%BC%D0%B0%D0%BD%D0%B4%D0%B0-The-Russian-Team",
                countries: ["RU", "BY", "KZ", "KG"],
            },
        ],
        [
            "rw",
            {
                languageName: t`Kinyarwanda`,
                countries: ["RW"],
            },
        ],
        [
            "sl",
            {
                languageName: t`Slovenian`,
                countries: ["SI"],
            },
        ],
        [
            "so",
            {
                languageName: t`Somali`,
                countries: ["SO"],
            },
        ],
        [
            "sq",
            {
                languageName: t`Albanian`,
                countries: ["AL"],
            },
        ],
        [
            "sr",
            {
                languageName: t`Serbian`,
                url: "https://sr.khanacademy.org/",
                countries: ["RS"],
            },
        ],
        [
            "sv",
            {
                languageName: t`Swedish`,
                url: "https://sv.khanacademy.org",
                countries: ["SE"],
            },
        ],
        [
            "sw",
            {
                languageName: t`Swahili`,
                url: "https://sw.khanacademy.org",
                countries: ["TZ"],
            },
        ],
        [
            "ta",
            {
                languageName: t`Tamil`,
                url: "https://ta.khanacademy.org",
                countries: ["IN", "LK", "MY"],
            },
        ],
        [
            "te",
            {
                languageName: t`Telugu`,
                url: "https://te.khanacademy.org",
                countries: ["IN"],
            },
        ],
        [
            "th",
            {
                languageName: t`Thai`,
                url: "https://th.khanacademy.org",
                countries: ["TH"],
            },
        ],
        [
            "tr",
            {
                languageName: t`Turkish`,
                url: "https://tr.khanacademy.org/",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360037662392-T%C3%BCrk-tak%C4%B1m%C4%B1-The-Turkish-Team",
                countries: ["TR", "CY", "MK", "GR"],
            },
        ],
        [
            "uk",
            {
                languageName: t`Ukrainian`,
                url: "https://uk.khanacademy.org",
                countries: ["UA"],
            },
        ],
        [
            "ur",
            {
                languageName: t`Urdu`,
                url: "https://ur.khanacademy.org",
                countries: ["IN", "PK"],
            },
        ],
        [
            "uz",
            {
                languageName: t`Uzbek`,
                url: "https://uz.khanacademy.org/",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360032219511",
                countries: ["UZ"],
            },
        ],
        [
            "vi",
            {
                languageName: t`Vietnamese`,
                url: "https://vi.khanacademy.org/",
                teamUrl:
                    "https://support.khanacademy.org/hc/en-us/articles/360059513772-Nh%C3%B3m-Vi%E1%BB%87t-Nam-The-Vietnamese-Team",
                countries: ["VN"],
            },
        ],
        [
            "xh",
            {
                languageName: t`Xhosa`,
                url: "https://xh.khanacademy.org",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360024203131-isiXhosa-isiZulu-Xhosa-and-Zulu-team",
                countries: ["ZA"],
            },
        ],
        [
            "zh-hans",
            {
                languageName: t`Chinese (Simplified)`,
                url: "https://zh-hans.khanacademy.org/",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360012809592-%E7%AE%80%E4%BD%93%E4%B8%AD%E6%96%87%E6%96%87%E6%9C%AC%E7%BF%BB%E8%AF%91%E5%9B%A2%E9%98%9F-The-Simplified-Chinese-Translation-Team",
                countries: ["CN", "SG"],
            },
        ],
        [
            "zh-hant",
            {
                languageName: t`Chinese (Traditional)`,
                countries: ["CN", "HK", "MO", "TW"],
            },
        ],
        [
            "zu",
            {
                languageName: t`Zulu`,
                url: "https://zu.khanacademy.org",
                teamUrl:
                    "https://khanacademy.zendesk.com/hc/en-us/articles/360024203131-isiXhosa-isiZulu-Xhosa-and-Zulu-team",
                countries: ["ZA"],
            },
        ],
    ]);

// sync-end:locales

export default getLanguages;
